<template>
  <v-dialog
    persistent
    max-width="480"
    :value="show"
  >
    <v-card>
      <v-card-title>System Error</v-card-title>

      <v-card-text class="whitespace-pre-wrap">
        このログインメールアドレスは、すでに利用されています。<br>
        別のメールアドレスに変更してください。
      </v-card-text>

      <v-card-actions>
        <v-spacer/>

        <v-btn color="primary" type="button" @click="$emit('change', false)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CErrorDialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>
